import React from "react";
import "./styles/Profile.css";
import ProfileLayout from "../components/ProfileLayout";
import { Link } from "react-router-dom";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import * as actions from "../redux/actions/sessionActions";
import * as actions_sesion from "../redux/actions/sessionActions";
import { FaKey, FaArrowLeft, FaCheck } from "react-icons/fa";
import alertify from "alertifyjs";
import "../components/styles/Alertify.css";
import "../components/styles/AlertifyTheme.css";
import "../components/styles/Alertify.min.css";
import "../components/styles/AlertifyTheme.min.css";
import { I18n, Translate } from "react-redux-i18n";

class ProfilePassword extends React.Component {
  state = {
    form: {
      password: "",
      password_confirmation1: "",
      password_confirmation2: "",
    },
    verified: false,
  };

  handleChange = (e) => {
    this.setState({
      form: {
        ...this.state.form,
        [e.target.name]: e.target.value,
      },
    });
  };

  onClickCheckPassword = async () => {
    await this.props
      .CheckPassword(
        this.state.form.password,
        this.props.user_id,
        this.props.token
      )
      .then(() => {
        if (this.props.error_update) {
          this.props.Logout();
          this.props.history.push("/login");
        } else {
          this.setState({ verified: true });
          alertify.success(I18n.t("saved_succesfull"));
        }
      });
  };

  onClickUpdatePassword = async () => {
    const { password_confirmation1, password_confirmation2, password } =
      this.state.form;

    if (!password_confirmation1 || !password_confirmation2) {
      alertify.alert(
        I18n.t("warning"),
        I18n.t("warning_password_confirm"),
        function () {}
      );
      return;
    }

    if (password_confirmation1 !== password_confirmation2) {
      alertify.alert(
        I18n.t("warning"),
        I18n.t("warning_password_similar"),
        function () {}
      );
      return;
    }

    await this.props
      .ResetPassword(
        password,
        password_confirmation2,
        this.props.user_id,
        this.props.token
      )
      .then(() => {
        if (this.props.error_update) {
          alertify.alert(I18n.t(this.props.error_update));
        } else {
          alertify.success(I18n.t("saved_succesfull"));
          this.setState({
            verified: false,
            form: {
              password: "",
              password_confirmation1: "",
              password_confirmation2: "",
            },
          });
        }
      });
  };

  render() {
    const { form, verified } = this.state;

    return (
      <ProfileLayout>
        <div className="profile-data-page profile-edit-page">
          <div className="card profile-edit-card">
            <div className="profile-edit-header profile-data-header">
              <Link to="/profile" className="profile-edit-back" aria-label="Back">
                <FaArrowLeft />
              </Link>
              <div>
                <h3 className="profile-edit-title">
                  <Translate value="password_change" />
                </h3>
                <p className="profile-edit-subtitle">
                  @{this.props.profile?.username || ""}
                </p>
              </div>
            </div>

            <div className="profile-edit-form">
              <section className="profile-password-step">
                <h4 className="profile-password-step__title">
                  <Translate value="password_current" />
                </h4>
                <div className="profile-password-verify-row">
                  <div className="profile-password-input-wrap">
                    <span className="profile-password-input-icon">
                      <FaKey />
                    </span>
                    <input
                      className="form-control profile-edit-input"
                      onChange={this.handleChange}
                      maxLength="100"
                      value={form.password}
                      autoComplete="current-password"
                      placeholder={I18n.t("profile_password")}
                      name="password"
                      type="password"
                      disabled={verified}
                    />
                  </div>
                  <button
                    type="button"
                    className="profile-password-verify-btn"
                    onClick={this.onClickCheckPassword}
                    disabled={verified || !form.password}
                  >
                    <FaCheck />
                    OK
                  </button>
                </div>
              </section>

              <section
                className={`profile-password-step${
                  !verified ? " profile-password-locked" : ""
                }`}
              >
                <h4 className="profile-password-step__title">
                  <Translate value="password_new" />
                </h4>
                <p className="profile-password-step__hint">
                  <Translate value="password_tip" />
                </p>

                <div className="profile-password-grid">
                  <div className="profile-password-field">
                    <label className="profile-edit-label">
                      <Translate value="password_new" />
                    </label>
                    <div className="profile-password-input-wrap">
                      <span className="profile-password-input-icon">
                        <FaKey />
                      </span>
                      <input
                        className="form-control profile-edit-input"
                        onChange={this.handleChange}
                        maxLength="100"
                        value={form.password_confirmation1}
                        autoComplete="new-password"
                        placeholder={I18n.t("profile_password")}
                        disabled={!verified}
                        pattern="(?=.*\\d)(?=.*[a-z])(?=.*[A-Z]).{6,}"
                        title={I18n.t("password_tip")}
                        required
                        name="password_confirmation1"
                        type="password"
                      />
                    </div>
                  </div>

                  <div className="profile-password-field">
                    <label className="profile-edit-label">
                      <Translate value="password_confirm" />
                    </label>
                    <div className="profile-password-input-wrap">
                      <span className="profile-password-input-icon">
                        <FaKey />
                      </span>
                      <input
                        className="form-control profile-edit-input"
                        onChange={this.handleChange}
                        maxLength="100"
                        value={form.password_confirmation2}
                        autoComplete="new-password"
                        placeholder={I18n.t("profile_password")}
                        disabled={!verified}
                        required
                        name="password_confirmation2"
                        type="password"
                      />
                    </div>
                  </div>
                </div>
              </section>

              <div className="profile-password-actions">
                <Link to="/profile" className="profile-edit-back-link">
                  <FaArrowLeft />
                  <Translate value="back" />
                </Link>
                <button
                  type="button"
                  className="btn btn-primary profile-edit-save"
                  onClick={this.onClickUpdatePassword}
                  disabled={!verified}
                >
                  <Translate value="save" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </ProfileLayout>
    );
  }
}

function mapStateToProps(reducer) {
  return {
    user_id: reducer.session.auth.id,
    token: reducer.session.auth.access_token,
    profile: reducer.session.auth,
    error_update: reducer.session.error_update,
  };
}

const mapDispatchToProps = (dispatch) => ({
  ResetPassword: (password_old, password_new, user_id, token) =>
    dispatch(
      actions.resetPassword({ password_old, password_new, user_id, token })
    ),
  CheckPassword: (password, user_id, token) =>
    dispatch(actions.checkPassword({ password, user_id, token })),
  Logout: () => dispatch(actions_sesion.logoutRequest({})),
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ProfilePassword)
);
